import { IpadConfigUpdate } from '@/features/ipad-configs/components';

const IpadConfigurationUpdatePage = () => {
  return <IpadConfigUpdate />;
};

export default IpadConfigurationUpdatePage;
